import type { AccommodationDto } from '@hcr/api/consumer'

import type { Guests } from '../../models'

export const createAccommodationGuests = (accommodation: AccommodationDto): Guests => ({
  adults: accommodation.adults,
  children: accommodation.children,
  universal: 0,
})
